<template>
  <su-page>
    <el-row class="mt10 f14" slot="content">
      <div class="mb10">{{ contactUs.address }} 邮政编码 100085</div>
      <div class="mb10">联系人：{{ contactUs.name }}</div>
      <div class="mb10">电话：{{ contactUs.mobile }}</div>
      <div class="mb10">邮件：{{ contactUs.email }}</div>
      <div class="mb10">客服微信：{{ contactUs.wx_account }}
<!--        手机：{{ contactUs.mobile }}-->
      </div>
      <el-image
          v-if="contactUs.location"
          class="mt20"
          style="width: 387px; height: 240px"
          :src="contactUs.location"
          :preview-src-list="[contactUs.location]"
      ></el-image>
    </el-row>
  </su-page>
</template>
<script>

import {contact} from "@/api/api";

export default {
  name: "contactUs",
  data() {
    return {
      contactUs: {},
    }
  },
  created() {

  },
  mounted() {
    this.contact()
  },
  methods: {
    contact() {
      contact().then(res => {
        if (res.status === 200) {
          this.contactUs = res.data
        }
      })
    },
  }
}
</script>


<style scoped lang="scss">

</style>
